/// Enum for user actions
export enum UserAction {
  MIGRATE_EMAIL = "migrate_email",
  RESEND_ACTIVATION = "resend_activation",
  SEND_NOTIFICATION = "send_notification",
  ASSOCIATE_STRIPE_SUB = "associate_stripe_sub",
}
